import { Injectable, inject } from '@angular/core';
import { AuthLogin, AuthLoginResponse, ConfirmForgotPasswordRequest } from '../models/auth.model';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { DataEndpoint } from '@core/models/general.model';

@Injectable({
  providedIn: 'root',
})
export class AuthApi {
  private readonly http = inject(HttpClient);
  private readonly AUTH = '/Auth';

  postLogin(request: AuthLogin): Observable<DataEndpoint<AuthLoginResponse>> {
    const url = `${this.AUTH}/Login`;
    return this.http.post<DataEndpoint<AuthLoginResponse>>(url, request)
      .pipe(map((data: DataEndpoint<AuthLoginResponse>) => {
        return {...data}
      })); 
  }

  postForgotPassword(email: string): Observable<DataEndpoint<any>> {
    const url = `${this.AUTH}/ForgotPassword`;
    return this.http.post<DataEndpoint<any>>(url, {Email: email})
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      })); 
  }

  postConfirmForgotPassword(request: ConfirmForgotPasswordRequest): Observable<DataEndpoint<any>> {
    const url = `${this.AUTH}/ConfirmForgotPassword`;
    return this.http.post<DataEndpoint<any>>(url, request)
      .pipe(map((data: DataEndpoint<any>) => {
        return {...data}
      })); 
  }
}
